import { FC } from 'react';
import PresentationModal from '../../organisms/PresentationModal';

interface ScriptModalProps {
    id: string;
    show: boolean;
    script: string;
    onClose: () => void;
}

const ScriptModal: FC<ScriptModalProps> = ({ id, show, script, onClose }) => {
    return (
        <PresentationModal id={id} show={show} onClose={onClose} header="Script" height="400px">
            <div className="p-4">
                <pre className="whitespace-pre-wrap text-xs bg-slate-100 p-2 rounded">
                    {script}
                </pre>
            </div>
        </PresentationModal>
    );
};

export default ScriptModal;
